

import './bordereau.css';
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';
import { communes, typeDeliveries, typeRamassages, wilayas } from '../../data';
import { CURRENT_URL } from "../../config/runtimeConfig";

function Bordereau({ envoie, state, agences }) {
    // -> npm i html2canvas
    // -> npm i jspdf
    // -> npm i react-barcode --legacy-peer-deps
    // -> npm i react-qr-code

    // var envoieId = `000000000${envoie.id}`.slice(-9);
    var envoieId = envoie.tracking

    // sender name length : 15
    // receiver name length : 40
    // receiver address length : 40

    return (
        <div className='slip-bord'>
            <div className="slip-container">
                <div className="slip-logo">
                    <img src={`${CURRENT_URL}//nweblack.png`} />
                </div>
                <div style={{ display: 'flex', columnGap: "10px", alignItems: "center", }}>
                    <QRCode value={`${envoie.id}-${envoie.User ? envoie.User.username : ''}`} size={65} />
                    {
                        state === "NWE" ? (
                            <div className='slip-infos sender'>
                                <div className="slip-title">Expéditeur</div>
                                <div className="slip-content">
                                    <div className="slip-row">
                                        <span>{(envoie.nomDeparture).length < 15 ? (envoie.nomDeparture) : (envoie.nomDeparture).substring(0, 14)}</span>
                                    </div>
                                    <div className="slip-row">
                                        <span>{wilayas.filter(item => item.id === envoie.wilayaDeparture)[0] ? wilayas.filter(item => item.id === envoie.wilayaDeparture)[0]['nom'] : ""}</span>
                                    </div>
                                    <div className="slip-row">
                                        <span>{envoie.tel1Departure}</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='slip-infos sender'>
                                <div className="slip-title">Expéditeur</div>
                                <div className="slip-content">
                                    <div className="slip-row">
                                        <span>{(envoie.nomArrived).length < 15 ? (envoie.nomArrived) : (envoie.nomArrived).substring(0, 14)}</span>
                                    </div>
                                    <div className="slip-row">
                                        <span>{wilayas.filter(item => item.id === envoie.wilayaArrived)[0] ? wilayas.filter(item => item.id === envoie.wilayaArrived)[0]['nom'] : ""}</span>
                                    </div>
                                    <div className="slip-row">
                                        <span>
                                            {
                                                envoie.typeDelivery === 1 ? (
                                                    communes[envoie.wilayaArrived].filter(item => item.id === envoie.communeArrived)[0] ? communes[envoie.wilayaArrived].filter(item => item.id === envoie.communeArrived)[0]['nom'] : ""
                                                ) : (
                                                    "Stop Desk"
                                                )
                                            }
                                        </span>
                                    </div>
                                    <div className="slip-row">
                                        <span>{envoie.tel1Arrived}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="slip-container">
                <Barcode value={`${state}-${envoieId}`} width={3} height={100} fontSize={18} />
            </div>
            <div className="slip-container">
                <div className='slip-infos receiver'>
                    <div className="slip-content">
                        <div className="slip-row">
                            {
                                state === "NWE" ? (
                                    <span>{typeDeliveries.filter(item => item.id === envoie.typeDelivery)[0]['nom'].slice(10)}</span>
                                ) : (
                                    <span>{typeRamassages.filter(item => item.id === envoie.typeRamassage)[0]['nom'].slice(6)}</span>
                                )
                            }
                        </div>
                        {
                            <div className="slip-row">
                                <span>{envoie.numero}</span>
                            </div>
                        }
                        {
                            envoie.weight >= 3 && (
                                <div className="slip-row">
                                    <span>{Number.parseFloat(envoie.weight).toFixed(2)} KG</span>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className='slip-infos receiver'>
                    <div className="slip-title">Destinataire</div>
                    {
                        state === "NWE" ? (
                            <div className="slip-content">
                                <div className="slip-row">
                                    <span>{(envoie.nomArrived).length < 40 ? (envoie.nomArrived) : envoie.nomArrived.substring(0, 40)}</span>
                                </div>
                                <div className="slip-row">
                                    {
                                        envoie.typeDelivery === 1 ? (
                                            <>
                                                <span>{(envoie.addressArrived).length < 40 ? (envoie.addressArrived) : (envoie.addressArrived).substring(0, 40)}</span>
                                                <br />
                                                {
                                                    communes[envoie.wilayaArrived].filter(item => item.id === envoie.communeArrived)[0] && <span>{communes[envoie.wilayaArrived].filter(item => item.id === envoie.communeArrived)[0]['nom']}</span>
                                                }
                                            </>
                                        ) : (
                                            <span>{agences.filter(item => item.id === envoie.agenceArrived)[0] ? agences.filter(item => item.id === envoie.agenceArrived)[0]['nom'] : ""}</span>
                                        )
                                    }
                                </div>
                                <div className="slip-row">
                                    <span>{envoie.tel1Arrived}</span>
                                </div>
                            </div>
                        ) : (
                            <div className="slip-content">
                                <div className="slip-row">
                                    <span>{envoie.nomDeparture}</span>
                                </div>
                                <div className="slip-row">
                                    {
                                        envoie.typeRamassage === 1 ? (
                                            <span>{(envoie.addressDeparture).length < 40 ? (envoie.addressDeparture) : (envoie.addressDeparture).substring(0, 40)}</span>
                                        ) : (
                                            <span>{agences.filter(item => item.id === envoie.agenceDeparture)[0] ? agences.filter(item => item.id === envoie.agenceDeparture)[0]['nom'] : ""}</span>
                                        )
                                    }
                                </div>
                                <div className="slip-row">
                                    <span>{envoie.tel1Departure}</span>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="slip-container">
                {
                    (state === "NWE") ? (
                        <div className="slip-big">
                            <span>{`${Number.parseFloat(envoie.montant).toFixed(2)} DA`}</span>
                            <span className='big'>{`${envoie.wilayaArrived}`}</span>
                        </div>
                    ) : (
                        (state === "PKP") ? (
                            <div className="slip-big">
                                <span>{`${Number.parseFloat(envoie.montant).toFixed(2)} DA`}</span>
                                <span className='big'>{`${envoie.wilayaDeparture}`}</span>
                            </div>
                        ) : (
                            <div className="slip-big">
                                <span style={{ opacity: "0", visibility: "hidden" }}>0.00</span>
                                <span className='big'>{`${envoie.wilayaDeparture}`}</span>
                            </div>
                        )
                    )
                }
            </div>
        </div>
    )
}

export default Bordereau
